/**
 * Gallery lightbox.
 *
 * Progressive enhancement: the grid works without JS, this only adds the
 * overlay. Uses a native <dialog> so focus trapping and Esc come for free.
 */
window.Blockline = window.Blockline || {};

window.Blockline.lightbox = ( function () {
	'use strict';

	var dialog = null;
	var image = null;
	var caption = null;

	function build() {
		if ( dialog ) {
			return dialog;
		}

		dialog = document.createElement( 'dialog' );
		dialog.className = 'bl-lightbox';
		dialog.innerHTML =
			'<button type="button" class="bl-lightbox__close" aria-label="Close">&times;</button>' +
			'<figure class="bl-lightbox__figure">' +
			'<img class="bl-lightbox__image" src="" alt="" />' +
			'<figcaption class="bl-lightbox__caption"></figcaption>' +
			'</figure>';

		image = dialog.querySelector( '.bl-lightbox__image' );
		caption = dialog.querySelector( '.bl-lightbox__caption' );

		dialog.querySelector( '.bl-lightbox__close' ).addEventListener( 'click', function () {
			dialog.close();
		} );

		// Click the backdrop to dismiss.
		dialog.addEventListener( 'click', function ( event ) {
			if ( event.target === dialog ) {
				dialog.close();
			}
		} );

		document.body.appendChild( dialog );

		return dialog;
	}

	function open( trigger ) {
		var node = build();

		image.src = trigger.dataset.full;
		image.alt = trigger.getAttribute( 'aria-label' ) || '';
		caption.textContent = trigger.dataset.caption || '';
		caption.hidden = ! trigger.dataset.caption;

		if ( typeof node.showModal === 'function' ) {
			node.showModal();
		}
	}

	function init() {
		var galleries = document.querySelectorAll( '.bl-gallery[data-lightbox="true"]' );

		if ( ! galleries.length || typeof HTMLDialogElement === 'undefined' ) {
			return;
		}

		galleries.forEach( function ( gallery ) {
			gallery.addEventListener( 'click', function ( event ) {
				var trigger = event.target.closest( '.bl-gallery__trigger' );

				if ( trigger && trigger.dataset.full ) {
					open( trigger );
				}
			} );
		} );
	}

	return { init: init };
} )();
